import { Components, Theme, ThemeOptions } from '@mui/material/styles';

const getBreadcrumbTheme = (theme: Theme): ThemeOptions => {
  const breadcrumbTheme: Components<Theme>['MuiBreadcrumbs'] = {
    defaultProps: {
      'aria-label': 'breadcrumb',
    },
    styleOverrides: {
      root: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.unit(2), // 8px between items
        // Style for typography (last item) inside breadcrumbs
        '& .MuiTypography-root': {
          ...theme.typography.M3.label.large,
          color: theme.palette.M3.black,
          cursor: 'default',
        },
        // Style for links inside breadcrumbs
        '& .MuiLink-root': {
          ...theme.typography.M3.body.medium,
          color: theme.palette.M3.sys.light['on-primary-container'],
          textDecoration: 'none',
          cursor: 'pointer !important',
          '&:hover': {
            textDecoration: 'underline',
          },
        },
      },
      separator: {
        display: 'flex',
        alignItems: 'center',
        margin: 0,
        color: theme.palette.M3.sys.light['on-surface-variant'],
        '& svg': {
          fontSize: '24px',
          width: '24px',
          height: '24px',
        },
      },
      li: {
        display: 'flex',
        alignItems: 'center',
      },
    },
  };

  return {
    components: {
      MuiBreadcrumbs: breadcrumbTheme,
    },
  };
};

export default getBreadcrumbTheme;
